export const SETTINGS_WORKFLOW_HISTORY_IS_SUBMIT_ENABLED =
  "SETTINGS_WORKFLOW_HISTORY_IS_SUBMIT_ENABLED";
